import React from "react"

import type { Stakeholder } from "../../../../types/types"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import StakeholderEditItemDetails from "./StakeholderEditItemDetails"
import StakeholderRelationshipsEditWidget from "../../../common/StakeholderRelationshipsEditWidget"

type Props = {
    model: Stakeholder,
    onEventChange: void => void,
    onImageChange: void => void
}

const StakeholderEditItem = ({
    model,
    onEventChange,
    onImageChange
}: Props) => {
    return (
        <ItemDetailsColumns>
            <ItemDetailsColumn>
                <StakeholderEditItemDetails
                    full_name={model.full_name}
                    bio={model.bio}
                    primary_organisation={model.primary_organisation}
                    primary_position={model.primary_position}
                    photo_url={model.photo_url}
                    type={model.type}
                    imagePreviewURL={model.imagePreviewURL}
                    onEventChange={onEventChange}
                    onImageChange={onImageChange}
                />
            </ItemDetailsColumn>
            <ItemDetailsColumn>
                <StakeholderRelationshipsEditWidget
                    stakeholderType={model.type}
                />
            </ItemDetailsColumn>
        </ItemDetailsColumns>
    )
}

export default StakeholderEditItem
